/* eslint-disable class-methods-use-this */
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { FOLDER_ENDPOINTS, foldersUrl } from 'SharedDir/backend/endpoints/folders';
import { FileFull } from 'SharedDir/declarations/files';
import { Folder, FolderCore } from 'SharedDir/declarations/filesystem';
import fileDownloader from 'SharedDir/utils/file-downloader';

export default class FoldersApiClass extends SimpleApi<
  Folder,
  FolderCore,
  Omit<FolderCore, 'parentId'>,
  never
> {
  constructor() {
    super(foldersUrl);
  }

  async linkFile(folderId: number, fileId: string) {
    const { data } = await http<FileFull>(FOLDER_ENDPOINTS.LINK_FILE(folderId, fileId));
    return data;
  }

  async unlinkFile(folderId: number, fileId: string) {
    const { data } = await http<FileFull>(FOLDER_ENDPOINTS.UNLINK_FILE(folderId, fileId));
    return data;
  }

  async moveFile(sourceFolderId: number, fileId: string, targetFolderId: number) {
    const { data } = await http<FileFull>({
      ...FOLDER_ENDPOINTS.MOVE_FILE(sourceFolderId, fileId),
      data: { targetFolderId },
    });
    return data;
  }

  async moveFolder(folderId: number, targetParentId: number, sourceParentId?: number) {
    const { data } = await http<Folder>({
      ...FOLDER_ENDPOINTS.MOVE_FOLDER(folderId),
      // sourceParentId обязателен, если у папки несколько родителей (см. move_copy._resolve_source_parent_id).
      data: { targetParentId, sourceParentId },
    });
    return data;
  }

  async copyFolder(folderId: number, targetParentId: number) {
    const { data } = await http<Folder>({
      ...FOLDER_ENDPOINTS.COPY_FOLDER(folderId),
      data: { targetParentId },
    });
    return data;
  }

  /**
   * Скачивание zip папки (KMNS-2060).
   *
   * `responseType: 'blob'` обязателен: иначе axios попытается распарсить
   * zip как JSON и файл на диске будет битый. Имя берём из
   * Content-Disposition через fileDownloader — не хардкодим, бэк уже
   * кладёт `{folder.name}.zip`.
   *
   * Perm: `file.list`. Откреплённые ЭП попадают внутрь архива как `*.sig`.
   */
  async downloadArchive(folderId: number) {
    const response = await http({
      ...FOLDER_ENDPOINTS.DOWNLOAD_ARCHIVE(folderId),
      responseType: 'blob',
    });

    fileDownloader.saveFileFromResponse(response);

    return response;
  }
}
